import { useSelector, shallowEqual } from 'react-redux';

import {
  selectMoveInDate,
  selectAccountId,
  selectGasMeterPointId,
  selectElectricityMeterPointId,
  selectElectricityRegisters,
  selectGasRegisters
} from 'state/move-in-date/move-in-date-slice';
import { selectMeterReads } from 'state/meter-reads/move-in-meter-read-slice';
import moment from 'moment';
import { DATE_FORMAT } from 'config/app-config';

export const useMeterReadsPayload = () => {
  const moveInDate = useSelector(selectMoveInDate, shallowEqual);
  const accountId = useSelector(selectAccountId, shallowEqual);
  const electricityRegisters = useSelector(
    selectElectricityRegisters,
    shallowEqual
  );
  const gasRegisters = useSelector(selectGasRegisters, shallowEqual);
  const electricityMeterPointId = useSelector(
    selectElectricityMeterPointId,
    shallowEqual
  );
  const gasMeterPointId = useSelector(selectGasMeterPointId, shallowEqual);
  const meterReads = useSelector(selectMeterReads, shallowEqual);

  const getFuelReads = (registers) => {
    return registers?.reduce((acc, register) => {
      return [
        ...acc,
        ...(meterReads[register.id]
          ? [
              {
                value: parseInt(meterReads[register.id], 10),
                registerId: register.id
              }
            ]
          : [])
      ];
    }, []);
  };

  const electricityReads = getFuelReads(electricityRegisters);
  const gasReads = getFuelReads(gasRegisters);
  const hasElectricityReads = !!electricityReads?.length;
  const hasGasReads = !!gasReads?.length;

  if (!hasElectricityReads && !hasGasReads) {
    return null;
  }

  const formattedMoveInDate = moment(moveInDate, DATE_FORMAT, true)
    .utc(true)
    .format();

  return {
    accountId,
    moveInDate: formattedMoveInDate,
    meterPoints: [
      ...(hasElectricityReads
        ? [
            {
              meterPointId: electricityMeterPointId,
              readings: electricityReads
            }
          ]
        : []),
      ...(hasGasReads
        ? [
            {
              meterPointId: gasMeterPointId,
              readings: gasReads
            }
          ]
        : [])
    ]
  };
};
